/* eslint-disable no-undef */
import { useHistory } from 'react-router-dom';

export function redirectToLogout() {
  const history = useHistory();
  const logoutRedirectUrl = `/logout`;
  history.push(logoutRedirectUrl);
}

export function getUrlSearchParamValue(urlData, searchString) {
  // eslint-disable-next-line no-useless-escape
  searchString = searchString.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + searchString + '=([^&#]*)');
  var results = regex.exec(urlData);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function getStateValueForActiveUserSession() {
  const currentUri = window.location.href;
  let userRedirectPath = currentUri.split('#').pop();
  if (userRedirectPath && userRedirectPath !== '/') {
    sessionStorage.setItem('redirectPath', userRedirectPath);
    localStorage.setItem('isRedirectedPath', JSON.stringify(true));
  }
}

export default {
  redirectToLogout,
  getUrlSearchParamValue,
  getStateValueForActiveUserSession,
};
